/**
 * Timezone selector — UTC/ET segmented toggle with a live clock label for the
 * active zone. Shared by the main chart's NavigationBar and the /chart/renko
 * page so both toolbars expose the same control. Owns its own 1s clock so the
 * label keeps ticking wherever it is mounted. Uses the `.nav-seg` styling from
 * NavigationBar.css (imported here so it works outside the nav bar too).
 */
import { useState, useEffect } from 'react';
import './NavigationBar.css';

export default function TimezoneSelector({ timezone, onTimezoneChange }) {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const formatTime = (tz) => {
    return currentTime.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZone: tz === 'ET' ? 'America/New_York' : 'UTC',
    });
  };

  return (
    <div className="nav-seg">
      {['UTC', 'ET'].map((tz) => (
        <button
          key={tz}
          className={timezone === tz ? 'active' : ''}
          onClick={() => onTimezoneChange?.(tz)}
        >
          {tz} {timezone === tz && formatTime(tz)}
        </button>
      ))}
    </div>
  );
}
